import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './AppIcon';

const GoBackButton = ({ fallbackPath = '/', label = 'Go Back', className = '' }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history?.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  };

  return (
    <button
      onClick={handleBack}
      className={`flex items-center gap-1.5 text-sm transition-all hover:opacity-80 ${className}`}
      style={{ color: '#6B9EC4' }}
      onMouseEnter={e => e.currentTarget.style.color = '#00D4FF'}
      onMouseLeave={e => e.currentTarget.style.color = '#6B9EC4'}
    >
      <Icon name="ArrowLeft" size={16} color="currentColor" />
      <span>{label}</span>
    </button>
  );
};

export default GoBackButton;
